import { useCallback } from 'react'
import { getImagesFromApidList } from '../../../../shared/utils/getImagesFromApidList'
import { useGroupData, useImageOrganizeContext, useImageOrganizeModes } from '../../../views/imageBrowse/hooks'
import useViewMode from '../../../views/imageBrowse/hooks/useViewMode'
import { useSharedBrowserStateContext } from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

/**
 * useGetThumbnail - a function to get the ark and apid of the image that is getting focused
 *    Found out that sometimes when focusing on an image when viewing another item
 *    in a divided image group, that the thumbnails for the new child group are not updated before the new image ark is set. Here we
 *    will make sure that the correct ark is taken from the parent group when in a divided group.
 * @param {*} index - the index of the image that is getting focused
 */
export default function useGetThumbnail() {
  const { isDivideMode } = useImageOrganizeModes()
  const { viewMode } = useViewMode()
  const { initialGroup } = useGroupData()
  const originalImageApids = initialGroup?.imageApids
  const { thumbnails } = useSharedBrowserStateContext()

  const { dividerOffsets } = useImageOrganizeContext() // Group specific

  // childGroupIndex indicates only group tab worries about this
  const getThumbnail = useCallback(
    (index, childGroupIndex) => {
      const isDividedGroup = initialGroup?.childGroups?.length > 0
      const notViewingAllImagesInDividedGroup = isDividedGroup && viewMode === 'single' && !isDivideMode
      if (notViewingAllImagesInDividedGroup && typeof childGroupIndex === 'number' && childGroupIndex >= 0) {
        const inlineThumbnails = getImagesFromApidList(originalImageApids)
        const indexInParentGroup = index + dividerOffsets[childGroupIndex]
        return Array.isArray(inlineThumbnails) && inlineThumbnails[indexInParentGroup]
          ? inlineThumbnails[indexInParentGroup]
          : {}
      }
      if (thumbnails && thumbnails?.[index]?.ark) {
        return thumbnails[index]
      }
      return {}
    },
    [dividerOffsets, initialGroup, originalImageApids, viewMode, isDivideMode, thumbnails]
  )
  return getThumbnail
}
